// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-bar{background-color:#fff;width:100%;z-index:100;position:fixed;right:0;left:0;bottom:0;border-top:1px solid #c6ced5;height:60px}@media print{.mobile-bar{display:none !important}}.mobile-bar__container{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;padding:0 8px;margin:auto;height:100%;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}\n", ""]);
// Exports
module.exports = exports;
